import { render, staticRenderFns } from "./EditMeetingDocumentType.vue?vue&type=template&id=6fc88781&"
import script from "./EditMeetingDocumentType.vue?vue&type=script&lang=js&"
export * from "./EditMeetingDocumentType.vue?vue&type=script&lang=js&"
import style0 from "./EditMeetingDocumentType.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports